import { ProductType, useField } from '@kizi/comparator-core';
import { Div, P, ParagraphProps } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React from 'react';
import { parseProductFieldData } from '../utils/product';

export interface ApplyFormFooterProps {
  productSupplier: string;
  productType: ProductType;
  labelContainerProps?: ParagraphProps;
  lockContainerProps?: ParagraphProps;
}

interface ApplyFormFooterWrapperProps
  extends Omit<ApplyFormFooterProps, 'productSupplier'> {
  productFieldName: string;
}

export const ApplyFormFooter: React.FC<ApplyFormFooterProps> = ({
  productSupplier,
  productType,
  labelContainerProps,
  lockContainerProps,
}) => {
  const footerText: { type: ProductType; text: string }[] = [
    {
      type: ProductType.ENERGY,
      text: `Binnen zeven werkdagen ontvang je bevestiging van ${productSupplier} en krijg je je nieuwe contract toegestuurd. Als je je contract hebt ontvangen, heb je nog 14 dagen bedenktijd. Binnen deze periode kun je je energiecontract kosteloos en zonder reden opzeggen.`,
    },
    {
      type: ProductType.CAR,
      text: `Je ontvangt een bevestigingsmail van ${productSupplier} waarin staat of je per direct voorlopig geaccepteerd (en dus verzekerd) bent. Binnen 2 weken laat de verzekeraar weten of je definitief geaccepteerd bent en krijg je je polis toegestuurd. Als je je polis hebt ontvangen, heb je nog 14 dagen bedenktijd. Binnen deze periode kun je je autoverzekering kosteloos en zonder reden opzeggen.`,
    },
    {
      type: ProductType.HOME,
      text: `Binnen twee weken krijg je een brief van ${productSupplier}. Hierna heb je 14 dagen bedenktijd. In deze periode kun je de aanvraag kosteloos annuleren.`,
    },
    {
      type: ProductType['OS-HOME'],
      text: `Binnen twee weken krijg je een brief van ${productSupplier}. Hierna heb je 14 dagen bedenktijd. In deze periode kun je de aanvraag kosteloos annuleren.`,
    },
    {
      type: ProductType.TRIPLEPLAY,
      text: `Binnen enkele dagen krijg je een bevestiging van ${productSupplier}. Hierna heb je 14 dagen bedenktijd. In deze periode kun je de aanvraag kosteloos annuleren`,
    },
  ];

  return (
    <Div variant="applyFormFooterContainer">
      <P {...labelContainerProps} maxWidth="none">
        {footerText.find((x) => x.type === productType)?.text}
      </P>
      <P
        mt={2}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        maxWidth="none"
        {...lockContainerProps}
      >
        <Icon
          name="lock"
          mr={1}
          fill="supplementary.2"
          size={18}
          variant="iconLink"
        />
        Beveiligde verbinding
      </P>
    </Div>
  );
};

export const ApplyFormFooterWrapper: React.FC<ApplyFormFooterWrapperProps> = ({
  productFieldName,
  productType,
  ...props
}) => {
  const field = useField(productFieldName);

  if (!field || !field.value) return null;
  const _field = parseProductFieldData(field.value);

  return (
    <ApplyFormFooter
      productSupplier={_field.provider.name}
      productType={productType}
      {...props}
    />
  );
};
